import { useState } from 'react';

/* 다국어 텍스트 입력 (언어 탭 전환). value = { ko:'...', en:'...' } */
export function MLText({ value, onChange, langs, multiline, placeholder }) {
  const def = (langs.find(l => l.default) || langs[0]).code;
  const [lang, setLang] = useState(def);
  const val = value || {};
  const set = (t) => onChange({ ...val, [lang]: t });
  return (
    <div>
      <div className="langtabs">
        {langs.map(l => (
          <button key={l.code} type="button" className={"langtab" + (lang === l.code ? " is-on" : "")} onClick={() => setLang(l.code)}>
            <span className={"langtab__dot" + ((val[l.code] || '').trim() ? " is-filled" : "")}></span>{l.label}
          </button>
        ))}
      </div>
      {multiline
        ? <textarea className="textarea" value={val[lang] || ''} onChange={e => set(e.target.value)} placeholder={placeholder} />
        : <input className="input" value={val[lang] || ''} onChange={e => set(e.target.value)} placeholder={placeholder} />}
    </div>
  );
}

export default MLText;
